module.exports = __webpack_public_path__ + "static/media/et_6.65ba44e3.png";